export const isGCXDomain = () => {
  const currentUrl = window.location.hostname;
  return !!currentUrl.match(/gcx.raise/);
};
